'use strict';

DoohApps
    .factory('FileDownloadHelper', ['$http', 'DialogHandler', function ($http, DialogHandler) {
        
        return {
            downloadFileFromResponse: downloadFileFromResponse,
            saveAsJsonFile: saveAsJsonFile,
            downloadFile: downloadFile
        }

        function downloadFileFromResponse(responseData) {
            if (responseData.hasError) DialogHandler.AddError(responseData.error, true);
            else downloadFile(responseData.content);
            
        }

        function saveAsJsonFile(title, data) {
            var jsonTitle = title + '_' + moment().format('YYYY-MM-DD') + '.json';
            var blob = new Blob([data], {
                type: 'application/json;charset=utf-8'
            });
            saveAs(blob, jsonTitle);
        }

        function downloadFile(url) {
            
            var downloadLink = angular.element('<a></a>');
            downloadLink.attr('href', url);
            downloadLink.attr('download', '');
            downloadLink.attr('target','_blank')
            
            angular.element(document.body).append(downloadLink); //Append the element to work in firefox
            downloadLink[0].click();
            downloadLink.remove();
        }
        
    }]);